<template>
  <div class="bnr_box __web-inspector-hide-shortcut__">
    <p
      v-text="title"
      style="font-size: 30px; text-align:center;"
    />
  </div>
</template>

<script>
import {defineComponent, computed} from 'vue'

export default defineComponent({
  name: 'SearchTitleParts',
  type: {
    type: String,
    default: 'new',
  },
  setup(props) {
    const title = computed(() => {
      if (props.type === 'new') {
        return '新車在庫情報'
      } else if (props.type === 'used') {
        return '中古車在庫情報'
      } else if (props.type === 'test') {
        return '試乗車情報'
      }
    })
    return {
      title
    }
  }
})

</script>